module.exports = __webpack_public_path__ + "static/vmware_3.7f62cabb.png";